import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";
import Loading from "../components/Loading";

import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";
import Icon from "@material-ui/core/Icon";

import { createOrder, getOtp } from "../api";
import moment from "moment";
import { dispatch } from "../store";
import DhipLogo from "../assets/images/agreeDhip.png";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  container: {
    padding: "16px",
    backgroundColor: "white"
  },
  numberContainer: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px"
  },
  number: {
    ...fontDefault,
    fontSize: "16px",
    marginRight: "8px"
  },
  numberText: {
    ...fontDefault,
    fontSize: "16px"
  },
  flexSpace: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  fullWidth: {
    width: "100%"
  },
  widthDivider: {
    width: "16px",
    display: "block"
  },
  head: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold"
  }
};

class App extends Component {
  state = {
    isLoading: false
  };

  goToNextPage = async () => {
    const { auth = {} } = this.props;
    const { selectedPackage = {} } = auth;
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Conditions", {
        Insurer: "Dhipaya",
        "Insurance type": "Dhipaya Corona",
        "Insurance package": selectedPackage.name,
        Amount: selectedPackage.total_prem
      });
    }
    const {
      history: { push }
    } = this.props;
    push("/payment");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  backToPreviousPage = () => {
    const {
      history: { push }
    } = this.props;
    push("/summary");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  render = () => {
    const { classes } = this.props;
    const { isLoading } = this.state;
    return (
      <Wrapper>
        <Body>
          <div className={classes.container}>
            <img
              src={DhipLogo}
              style={{ height: "23px", left: "-3px", position: "relative" }}
            />
            <Typography className={classes.head}>
              ข้อกำหนดและเงื่อนไขประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อ
              ไวรัสโคโรนา (Coronavirus (2019-nCoV))
            </Typography>
            <br />
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>1.</Typography>
              <Typography className={classes.numberText}>
                เบี้ยประกันภัยข้างต้นรวมภาษีมูลค่าเพิ่ม 7% และอากรแสตมป์ 0.4%
                แล้ว
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>2.</Typography>
              <Typography className={classes.numberText}>
                ผู้ขอเอาประกันภัยต้องมีอายุระหว่าง 1 ปี - 99 ปี (ปี พ.ศ.
                ปัจจุบัน ลบด้วยปี พ.ศ. เกิด) ณ วันที ทําประกันภัย
                และต้องมีสุขภาพร่างกายสมบูรณ์แข็งแรง
                และผ่านการพิจารณารับประกันภัย
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>3.</Typography>
              <Typography className={classes.numberText}>
                กรมธรรม์ประกันภัยนี้ไม่คุ้มครองผู้ที่ติดเชื้อ
                หรือเป็นผู้ที่สงสัยว่าจะติดเชื้อ “โรคติดเชื้อไวรัสโคโรนา
                (Coronavirus (2019nCoV))” (รวมถึงภาวะแทรกซ้อน)
                ที่เป็นอยู่ก่อนการเอาประกันภัย และยังมิได้รักษาให้หายขาด
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>4.</Typography>
              <Typography className={classes.numberText}>
                จำกัดการซื้อ 1 คนต่อ 1 กรมธรรม์ทุกช่องทางจำหน่ายของ บมจ.ทิพยประกันภัย
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>5.</Typography>
              <Typography className={classes.numberText}>
                การเจ็บป่วยด้วยภาวะโคม่า หรือ ภาวะสมองตายและระบบประสาทล้มเหลว
                หรือ
                การเจ็บป่วยรุนแรงที่แพทย์ลงความเห็นว่าไม่มีวิธีการรักษาให้หายขาดได้
                และ/หรือ
                เป็นสาเหตุให้เสียชีวิตโดยมีสาเหตุหลักมาจากติดเชื้อไวรัสโคโรนา
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>6.</Typography>
              <Typography className={classes.numberText}>
                บริษัทฯ
                จำกัดจำนวนเงินความรับผิดชอบสูงสุดตลอดระยะเวลาเอาประกันภัย
                ไม่เกิน 200,000,000 บาท
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>7.</Typography>
              <Typography className={classes.numberText}>
                ไม่คุ้มครองการติดเชื้อไวรัสโคโรนา (Coronavirus (2019-nCoV)
                ภายในระยะเวลา 14 วัน (Waiting Period)
                นับจากวันที่กรมธรรม์ประกันภัยมีผลบังคับครั้งแรก
                สำหรับผู้เอาประกันภัยรายใหม่
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>8.</Typography>
              <Typography className={classes.numberText}>
                กรมธรรม์ประกันภัยนี้ให้การคุ้มครองภาวะแทรกซ้อน
                หรือผลข้างเคียงจากการฉีดวัคซีนเพื่อป้องกันโรคติดเชื้อไวรัสโคโรนา
                2019 (COVID-19) เป็นระยะเวลา 90
                วันนับจากวันที่ได้รับการฉีดวัคซีนโดยต้องเป็นวัคซีนที่รับการรับรอง
                หรือการอนุมัติจากสำนักงานคณะกรรมการอาหารและยา (Food and Drug
                Administration: FDA) และทำหัตถการโดยแพทย์ หรือพยาบาล
                ที่โรงพยาบาลหรือสถานพยาบาลเวชกรรม
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>9.</Typography>
              <Typography className={classes.numberText}>
                ไม่คุ้มครองภาวะแทรกซ้อนหรือผลข้างเคียงจากการฉีดวัคซีนเพื่อป้องกันโรคติดเชื้อไวรัสโคโรนา
                2019 (COVID-19)
                ก่อนวันที่กรมธรรม์ประกันภัยนี้เริ่มมีผลบังคับเป็นครั้งแรก
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>10.</Typography>
              <Typography className={classes.numberText}>
                ระยะเวลาเอาประกันภัย 1 ปีกรมธรรม์ประกันภัย
                นับตั้งแต่วันที่เริ่มความคุ้มครอง
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>11.</Typography>
              <Typography className={classes.numberText}>
                ระยะเวลาชำระเบี้ยประกัน ปีต่อปี
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>12.</Typography>
              <Typography className={classes.numberText}>
                ผลประโยชน์และความคุ้มครองเป็นไปตามข้อกำหนดและเงื่อนไขกรมธรรม์ประกันภัยคุ้มครองการติดเชื้อไวรัสโคโรนา
                (Coronavirus (2019-nCoV))
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>13.</Typography>
              <Typography className={classes.numberText}>
                ขณะซื้อกรมธรรม์ประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อไวรัสโคโรนา
                (Coronavirus (2019-nCoV))
                ผู้เอาประกันภัยต้องพำนักอาศัยอยู่ในประเทศไทย
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>14.</Typography>
              <Typography className={classes.numberText}>
                ข้อมูลการขอเอาประกันภัย เป็นส่วนหนึ่งของการพิจารณารับประกันภัย
                บริษัทฯ จะยืนยันการพิจารณารับประกันภัย
                และจัดส่งกรมธรรมน์ประกันภัยให้แก่ผู้ขอเอาประกันภัยภายใน 5
                วันทำการ
              </Typography>
            </div>
            <br />
            <Typography className={classes.head}>ข้อยกเว้นเพิ่มเติม</Typography>
            <br />
            <div className={classes.numberContainer}>
              <Typography className={classes.numberText}>
                สำหรับความคุ้มครองค่าใช้จ่ายในการตรวจหาโรคติดเชื้อไวรัสโคโรนา
                2019 (COVID-19) สำหรับบุคคลในครอบครัว
                และบุคคลที่อาศัยอยู่ร่วมกันกับผู้เอาประกันภัยเท่านั้นการประกันภัยภายใต้ข้อตกลงคุ้มครองนี้จะไม่คุ้มครอง
              </Typography>
            </div>
            <br />
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>1.</Typography>
              <Typography className={classes.numberText}>
                การลักลอบเข้ามาในราชอาณาจักรไทยโดยไม่ผ่านกระบวนการคัดกรองโรคติดเชื้อไวรัสโคโรนา
                2019 (COVID-19)
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>2.</Typography>
              <Typography className={classes.numberText}>
                การเรียกร้องค่าทดแทนที่เกิดจากการกระทำโดยทุจริต หรือมีเจตนาฉ้อฉล
                หรือสมรู้ร่วมคิดระหว่างผู้เอาประกันภัย
                ตัวแทนของผู้เอาประกันภัยหรือบุคคลใดที่กระทำในนามของผู้เอาประกันภัยเพื่อประโยชน์ของการประกันภัยนีโ้ดยทุจริต
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>3.</Typography>
              <Typography className={classes.numberText}>
                การเรียกร้องค่าทดแทนในกรณีที่ผู้เอาประกันภัยไม่ได้รับการตรวจหาโรคติดเชื้อไวรัสโคโรนา
                2019 (COVID-19)
              </Typography>
            </div>
            <div className={classes.numberContainer}>
              <Typography className={classes.number}>4.</Typography>
              <Typography className={classes.numberText}>
                การเรียกร้องค่าทดแทนในกรณีที่ผู้เอาประกันภัยไม่ได้รับวินิจฉัยจากแพทย์หรือแพทย์ผู้เชี่ยวชาญเฉพาะทางว่าเจ็บป่วยด้วยโรคติดเชื้อไวรัสโคโรนา
                2019 (COVID-19)
              </Typography>
            </div>
            <br />

            <div className={classes.flexSpace}>
              <div className={classes.fullWidth}>
                <SubmitButton onClick={this.backToPreviousPage} clear={true}>
                  ไม่ยอมรับ
                </SubmitButton>
              </div>
              <div className={classes.widthDivider} />
              <div className={classes.fullWidth}>
                <SubmitButton onClick={this.goToNextPage}>ยอมรับ</SubmitButton>
              </div>
            </div>
          </div>
          <Modal styles={{ outline: 0 }} open={isLoading}>
            <Loading />
          </Modal>
        </Body>
        <Header>
          <TopBar arrowLeft={this.backToPreviousPage}>
            <Typography align="center" className={classes.textTopBar}>
              เงื่อนไขการรับประกันภัย
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
